import { useEffect } from 'react';
import { useLoanStore } from '@roc/feature-loans';
import { observer } from 'mobx-react';
import { CustomCard } from '../customCard';
import { SelectField } from "@roc/ui";

export const LoanOriginatorCard = observer(({ readOnly = false }) => {
  const { loanStore } = useLoanStore();
  const { loanDetails } = loanStore;

  useEffect(() => {
    loanStore.getLoanParticipants();
    loanStore.loanParticipantsStore.setParticipants(loanDetails);
  }, []);

  const { originatorOptions, selectedOriginator } = loanStore?.loanParticipantsStore;
  const { loanOriginator } = loanDetails;
  const handleOriginatorChange = (originatorId) => {
    const result = originatorOptions.find(({ value }) => value === originatorId);
    loanStore?.loanParticipantsStore.setSelectedOriginator(result.label, originatorId)
    loanStore?.saveLoanParticipants();
  }

  return (
    <CustomCard
      paperNoShadow
      paperStyle={{
        height: '100%',
      }}
      title="Originator"
    >
      <SelectField
        disabled={readOnly}
        required={false}
        standaloneLabel
        label=""
        value={selectedOriginator?.originatorId ?? null}
        options={originatorOptions}
        // subLabel={originatorSubLabel}
        onChange={handleOriginatorChange}
        variant="outlined"
        fullWidth
        testId="loanOriginator"
      />
    </CustomCard>
  );
});
